import PropTypes from 'prop-types';

import Avatar from 'shopper/components/Avatar';
import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';
import Price from 'shopper/components/Price/V2';

import { sendEvent } from 'lib/gtag';
import { getOfferImageLink, toStoreImageAltText } from 'lib/image';
import placeholder from 'lib/placeholder';
import { getUtmsFromSession } from 'lib/sessionStorage';
import { sendSupixEvent } from 'lib/supix';

import { useUser } from 'providers/UserProvider';

const StoresRowCard = ({
  gaEventCategory,
  isPromobitHasTheBestPrice = false,
  offerCompareId,
  offerId,
  offerPrice,
  redirectUrl,
  storeImage,
  storeName,
}) => {
  const { LoggedInUser } = useUser();

  const onGoToStore = async () => {
    const utms = getUtmsFromSession();

    await sendSupixEvent('/ocout', {
      oid: offerId,
      ocid: offerCompareId,
      user_id: LoggedInUser?.userId,
      ...utms,
    });

    sendSupixEvent('/car', {
      category: 100020130,
    });

    sendEvent({
      action: 'go_store_compare',
      category: gaEventCategory,
      label: offerCompareId,
    });
  };

  return (
    <div className="rounded-5 border border-rd-neutral-300 px-6 py-4 dark:border-neutral-low-200">
      <div className="grid w-full grid-cols-2 grid-rows-2 items-center gap-1 md:flex md:items-center md:justify-between">
        <div className="flex items-center gap-x-4">
          <Avatar
            description={toStoreImageAltText(storeName)}
            icon="store"
            size="size4"
            src={getOfferImageLink(storeImage, 50)}
          />
          <Heading as="h3" size="size5">
            {storeName}
          </Heading>
        </div>
        <Price
          className="order-3 md:order-none md:col-span-1 md:ml-auto md:mr-6"
          primaryInfo={offerPrice}
          size="size2"
        />
        <Button
          as="a"
          className="row-span-2 w-20 justify-self-end md:w-48"
          href={redirectUrl}
          rel="noopener noreferrer"
          size="size2"
          target="_blank"
          type={isPromobitHasTheBestPrice ? 'primary-stroke' : 'primary'}
          onClick={onGoToStore}
        >
          {placeholder('actions.goToStore')}
        </Button>
      </div>
    </div>
  );
};

StoresRowCard.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  isPromobitHasTheBestPrice: PropTypes.bool,
  offerCompareId: PropTypes.number.isRequired,
  offerId: PropTypes.number.isRequired,
  offerPrice: PropTypes.number.isRequired,
  redirectUrl: PropTypes.string.isRequired,
  storeImage: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
};

export default StoresRowCard;
